<!--
 * @Description: 
 * @Author: 山淑兰
 * @Date: 2019-11-26 18:40:16
 * @LastEditTime: 2020-07-10 10:35:41
 * @LastEditors: 山淑兰
 -->
<template>
  <div id="transition">
    <Loading></Loading>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import Loading from '@components/Loading.vue'
import publicSignup from '../lib/signUp.js'

export default {
  name: 'transition',
  components: { Loading },
  data() {
    return {
      publicTools: {}, //通用publicSignup
    }
  },
  created() {
    this.publicTools = new publicSignup()
    if (this.publicTools.is_Mobile() === false) {
      let _params = window.location.href.split('?')[1]
      window.location.href = `https://mp.weiqihd.com/pweb/#/?${_params}`
    }
    if (this.isWeiXin()) {
      this.getToken()
    } else {
      if (this.$route.query.wxid) {
        this.getToken()
      } else {
        this.getTemporaryToken()
      }
    }
  },
  mounted() {
    document.title = 'loading...'
  },
  methods: {
    //判断是否为微信访问
    isWeiXin() {
      //window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
      var ua = window.navigator.userAgent.toLowerCase()
      //通过正则表达式匹配ua中是否含有MicroMessenger字符串
      if (ua.match(/MicroMessenger/i) == 'micromessenger') {
        return true
      } else {
        return false
      }
    },
    //微信授权
    goAuthorize() {
      let _url = window.location.href.split('#')[0]
      let prefix
      if (_url.indexOf('?') > 0) {
        let _urlNew = _url.split('?')[0]
        prefix = encodeURIComponent(_urlNew)
      }
      prefix = encodeURIComponent(_url)

      let suffix = encodeURIComponent(window.location.href.split('#')[1])
      const appid = 'wx1de2c88969681c5d'
      const redirect_uri = encodeURIComponent(
        window.location.origin +
          '/WxBase/BaseVueUserCallback?prefix=' +
          prefix +
          '&suffix=' +
          suffix
      )

      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirect_uri}&response_type=code&scope=snsapi_userinfo&state=wqzh089898989010101#wechat_redirect`
    },

    async getToken() {
      try {
        const { wxid } = this.$route.query
        // const { toUrl, wxid, m, channelId } = this.$route.query

        if (wxid) {
          const Res = await this.$http.verWxLogin({ wxid })

          const { accesstoken, exp } = Res
          const inFifteenMinutes = new Date(new Date() * 1 + exp * 1000)
          if (Res.Code === 6002) {
            Cookies.set('wqToken', accesstoken, {
              expires: inFifteenMinutes,
              path: '/',
            })
            this.$router.push({
              path: '/signup/meetingsignup',
              query: this.$route.query,
            })
          } else if (Res.Code === 6001) {
            Cookies.set('wqToken', accesstoken, { expires: inFifteenMinutes })
            this.$router.push({
              path: '/login',
              query: this.$route.query,
            })
          } else if (Res.Code === 8001) {
            this.goAuthorize()
          } else {
            this.$notify({
              message: Res.Msg,
              type: 'danger',
            })
          }
        } else {
          this.goAuthorize()
        }
      } catch (err) {
        this.$notify({
          message: err.message,
          type: 'danger',
        })
        console.log(err)
      }
    },
    //非微信
    async getTemporaryToken() {
      let Res = await this.$http.AccessTemp()
      const { accesstoken, exp } = Res
      const inFifteenMinutes = new Date(new Date().getTime() + exp * 60 * 1000)
      Cookies.set('wqToken', accesstoken, { expires: inFifteenMinutes })
      if (Res.Code === 1000) {
        this.$router.push({
          path: '/login',
          query: this.$route.query,
        })
      } else {
        this.$notify({
          message: Res,
          type: 'danger',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss"></style>
